export const ACCOUNT_TYPE_REQUIRED_LOOSING_PROVIDER_SPIDS = [
  "5278",
  "736D",
  "606E",
  "948G",
  "838E",
  "947G",
  "908A"
];

export const isAccountTypeRequiredForLoosingProvider = (loosingProvider?: string | null) =>
  !!loosingProvider &&
  ACCOUNT_TYPE_REQUIRED_LOOSING_PROVIDER_SPIDS.includes(loosingProvider.trim().toUpperCase());
